import { useCallback } from 'react';
import { useI18n } from 'next-localization';

import { DEFAULT_CHINA_LOCALE } from '@gn-audio/jss-core/common/constants';

const ENGLISH_LOCALE = 'en';

export const useFallbackTranslation = () => {
  const i18n = useI18n();
  const { t: i18nt } = i18n;
  const t: typeof i18nt = useCallback(
    (key, ...rest) => {
      const translation = i18nt(key, ...rest);
      if (translation) {
        return translation;
      } else {
        if (typeof key === 'string') {
          return key;
        } else {
          return JSON.stringify(key);
        }
      }
    },
    [i18nt]
  );

  // todo: Remove after coexistence period (re-enabling prefetch)
  const getURLWithLocalePrefix = useCallback(
    (href: string) => {
      const locale = i18n.locale().toLocaleLowerCase();
      const lowerHref = href.toLocaleLowerCase();
      const isDefaultChinaLocale = locale === DEFAULT_CHINA_LOCALE.toLocaleLowerCase();
      const isEnglishLocale = locale === ENGLISH_LOCALE.toLocaleLowerCase();
      const startsWithLocale = lowerHref.startsWith(`/${locale}`);

      if (href.startsWith('/') && !startsWithLocale) {
        return isEnglishLocale || isDefaultChinaLocale ? href : `/${locale}${href}`;
      }

      return href;
    },
    [i18n]
  );

  return { ...i18n, t, getURLWithLocalePrefix };
};
